<script setup lang="ts">
  import BulletPoint from '../tips/BulletPoint.vue';
</script>

<template>
  <div>
    <p><BulletPoint />documento.pdf (sem prefixo)</p>
    <p><BulletPoint />DA05-TESTE.pdf (sem sequencial)</p>
    <p><BulletPoint />DA-05.2-arquivo.pdf (formato incorreto)</p>
  </div>
</template>
